import React from 'react';
import { SmartUserPicker } from './SmartUserPicker';
import MessagesIntlProvider from './MessagesIntlProvider';
import { useUFOConcurrentExperience, smartUserPickerRenderedUfoExperience, UfoErrorBoundary } from '../ufoExperiences';
var SmartUserPickerWithIntlProvider = function SmartUserPickerWithIntlProvider(props) {
  var ufoId = props.inputId || props.fieldId;
  useUFOConcurrentExperience(smartUserPickerRenderedUfoExperience, ufoId);
  return /*#__PURE__*/React.createElement(UfoErrorBoundary, {
    id: ufoId
  }, /*#__PURE__*/React.createElement(MessagesIntlProvider, null, /*#__PURE__*/React.createElement(SmartUserPicker, props)));
};
export default SmartUserPickerWithIntlProvider;